<template>
    <div style="width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: stretch">
        <div style="flex-grow: 0; height: auto; padding: 10px; display: flex;">
            <v-spacer></v-spacer>
            <system-permission-group-create-button
                    type="RENTALCOMPANY"
            ></system-permission-group-create-button>
        </div>
        <div style="flex-grow: 1; height: 100%;">
            <vue-data-table
                    ref="dataTable"
                    :loading="loading"
                    :headers="headers"
                    :items="items"
                    @click:row="onClickRow"
            ></vue-data-table>
        </div>
    </div>
</template>

<script>
    import {PATH} from "@/constants";
    import OnSystemPermissionGroupReceivedListener from "@/framework/listeners/OnSystemPermissionGroupReceivedListener";
    import PermissionGroup from "@/model/permission-group";
    import SystemPermissionGroupCreateButton from "@/views/permission/group-manage/SystemPermissionGroupCreateButton";

    export default {
        name: "SystemPermissionGroupManageByRentalcompany",
        components: {SystemPermissionGroupCreateButton},
        mixins: [OnSystemPermissionGroupReceivedListener],
        data() {
            return {
                loading: false,
                items: [],
                headers: [
                    {
                        text: "그룹 코드",
                        value: "raw.code",
                    },
                    {
                        text: "그룹 이름",
                        value: "raw.name",
                    },
                    {
                        text: "권한 등급",
                        value: "raw.privilege",
                    },
                ],
            }
        },
        created() {
            this.load();
        },
        methods: {
            async load() {
                this.loading = true;
                try {
                    const res = await this.$request(PATH.SYSTEM_PERMISSION_GROUP.LIST_BY_RENTALCOMPANY)
                        .setObject({})
                        .catch()
                        .enqueue();
                    this.items = res.data.map(e => new PermissionGroup(e));
                } catch (e) {
                    console.error(e);
                    this.$alert(e.response.data.hri || "Unkown Error");
                }
                this.loading = false;
            },

            /**
             * 시스템 그룹이 업데이트 되었습니다. 데이터를 다시 로드합니다.
             */
            onSystemPermissionGroupReceived() {
                this.load();
            },

            onClickRow(item) {
                this.$router.push({name: "managertnbox.permission-group.system.manage.rentalcompany", params: {id: item.raw.id}});
            },
        }
    }
</script>

<style scoped>

</style>